<template>
  <div class="about  app-bg">
    <div class="about-header">
      <p>易才保险经纪致力于
        <br>为企业员工提供专业的保险服务
      </p>
    </div>
    <v-container class="pa-0">
      <v-layout column>
        <v-flex align-self-center>
          <h2>公司简介</h2>
        </v-flex>
        <v-flex>
          <article>
            <p>易才宏业保险经纪有限公司成立于2015年，由易才集团100%持股，注册资本金6000万元，是经原中国银行保险监督管理委员会批准设立的全国性保险经纪公司，且具备互联网保险销售资质。</p>
            <p>易才保险经纪以服务集团主营业务为核心，同时致力于服务中国的保险市场，面向全国提供财险、人身险、再保险经纪业务、风险管理咨询等服务，帮助客户实现全生命周期的风险管理！</p>
          </article>
        </v-flex>
      </v-layout>
      <!-- <v-layout column>
        <v-flex align-self-center>
          <h2>经营资质</h2>
        </v-flex>
        <v-flex shrink class="about-img">
          <v-layout justify-center wrap>
            <v-flex xs12 sm12 md6>
              <v-img  max-height="400px" contain
                     src="https://insurance-bs.wanhuahengxin.com/%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE/new-insurance-licence-1.jpg"></v-img>
            </v-flex>
            <v-flex xs12 sm12 md6>
              <v-img  max-height="400px" contain
                     src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/new-business-license.png"></v-img>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout> -->
      <v-layout column>
        <v-flex align-self-center>
          <h2 class="contact hidden-sm-and-down" id="contact">联系方式</h2>
        </v-flex>
        <v-flex class="contact">
          <v-layout row wrap>
            <v-flex md3 sm12 xs12>
              <h3>联系方式</h3>
            </v-flex>
            <v-flex md9 sm12 xs12>
              <ul style="border-top:none;margin: 0;padding: 0;">
                <!-- <li>
                  <p>
                    <span>商务合作：</span>孙建昊
                  </p>
                </li>
                <li>
                  <p>
                    <span>联系电话：</span>18601388369
                  </p>
                </li> -->
                <!-- <li>
                  <p>
                    <span>合作邮箱：</span>hezuo@chinatalentgroup.com
                  </p>
                </li> -->
                <li>
                  <p>
                    <span>联系邮箱：</span>ycbxjj@chinatalentgroup.com
                  </p>
                </li>
              </ul>
            </v-flex>
          </v-layout>
          <v-layout style="margin-top: 20px;"  row wrap>
            <v-flex  md3 sm12 xs12>
              <h3 style="padding-top: 20px;">办公地址</h3>
            </v-flex>
            <v-flex  md9 sm12 xs12>
              <ul style="padding-top: 20px;">
                <li class="mb-3">
                  <p>天津总部地址：天津市河西区黑牛城道与洞庭路交口东南侧五福大厦-1-1407、-1-1408</p>
                  <p>联系电话：022-88325599</p>
                </li>
                <li class="mb-3">
                  <p>北京分公司地址：北京市朝阳区康家沟145号一层A111</p>
                  <p>联系电话：010-50947006</p>
                </li>
                <li class="mb-3">
                  <p>陕西分公司地址：陕西省西安市碑林区长安北路113号永宁国际1号楼912室</p>
                  <p>联系电话：029-81331938</p>
                </li>
                <!-- <li class="mb-3">
                  <p>新疆分公司地址：新疆省乌鲁木齐市天山区光明路100号金碧华府1503室</p>
                  <p>联系电话：0991-8822023</p>
                </li>
                <li class="mb-3">
                  <p>甘肃分公司地址：甘肃省兰州市城关区闵家桥100号一楼049室</p>
                  <p>联系电话：0931-8187101</p>
                </li> -->
                <li class="mb-3">
                  <p>河北分公司地址：河北省石家庄市新华区中山西路83号东方大厦1202室</p>
                  <p>联系电话：0311-82623390</p>
                </li>
                <!-- <li class="mb-3">
                  <p>吉林分公司地址：长春市二道区东盛大街与荣光路交汇力旺·东玺台写字楼15栋703室</p>
                  <p>联系电话：0431-80745323</p>
                </li>
                <li class="mb-3">
                  <p>沧州分公司地址：河北省沧州高新区河北工业大学科技园4号楼2层209号房间</p>
                  <p>联系电话：</p>
                </li>
                <li class="mb-3">
                  <p>广西分公司地址：南宁市青秀区仙葫开发区仙葫大道西241、243号</p>
                  <p>联系电话：0771-3375441</p>
                </li>
                <li class="mb-3">
                  <p>江西分公司地址：江西省赣州市南康区东山街道办事处臻顺跨境电商产业园18栋1002[住所(经营场所)自主申报]</p>
                  <p>联系电话：0790-6656077</p>
                </li> -->
              </ul>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <div class="customer-container  app-bg">
        <v-container class="pa-0">
          <v-layout row justify-center>
            <section class="section">
              <h2 class="mb-4">客户服务及投诉渠道</h2>
              <div class="contact">
                <p>投保、理赔、保全服务及投诉电话：4006-234-345</p>
                <p class="contact-email">投诉邮箱：ycbxjj@chinatalentgroup.com</p>
                <!-- <v-img
                        max-height="200px"
                        contain
                        src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/kfwx2.jpg"
                ></v-img> -->
              </div>
            </section>
          </v-layout>
        </v-container>
      </div>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      year: 0,
    };
  },
  mounted() {
    // this.year = new Date().getFullYear() - 2003;
  }
};
</script>
<style lang="scss">
@media only screen and (min-width: 1280px){
  .about{
    .container {
      max-width: 900px !important;
    }
  }
}
.about {
  h2 {
    font-size: 36px;
    font-weight: 400;
    margin-bottom: 40px;
    margin-top: 60px;
  }
}
article p {
  text-indent: 2em;
  font-size: 16px;
  color: #666;
}
.contact {
  margin-bottom: 80px;
  h3 {
    width: 125px;
    font-size: 24px;
    color: #666;
    margin-right: 122px;
  }
  ul {
    color: #666;
    font-size: 16px;
    border-top: 1px solid #e5e5e5;
    padding-left: 0;

    p {
      margin-bottom: 0;
    }

    span {
      display: inline-block;
      width: 80px;
    }
  }
}
.about-header {
  width: 100%;
  height: 377px;
  background: url("/images/about/about-bg-new.png") no-repeat center center;
  background-size: cover;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
  }
}
@media screen and (max-width: 600px) {
  .about-header p{
    font-size:28px ;
  }
  .about {
    h2 {
      font-size: 26px;
      font-weight: 400;
      margin-bottom: 18px;
      margin-top: 50px;
    }
  }
  .contact{
    margin-top: 30px;
    h3{
      width: auto;
      text-align: center;
      margin-right: 0;
    }
    ul {
      color: #666;
      font-size: 16px;
      border-top:none;
      padding-left: 0;
    }
  }
  article,.about-img,.contact{
    padding: 0 15px;
  }
}
.customer-container{
  .des{
    box-shadow: 0px 0px 10px #ccc;
    padding:35px  0  50px;
    z-index: 1;
    background-color: #fff;
    position: relative;
    height: 297px;
    i{
      width: 98px;
      height: 3px;
      background-color: #DD122A;
      display: inline-block;
      margin-bottom: 48px;
    }
    h3{
      font-size: 36px;
      margin-bottom: 26px;
      font-weight: 400;
    }
    p{
      color: #666;
      font-size: 18px;
      margin-bottom: 26px;
    }
    a{
      border: 1px solid #DD122A;
      padding: 13px;
    }
  }
  .section {
    max-width: 900px;
    margin: 2em auto 0;
    padding: 15px;
    h2 {
      text-align: center;
      font-size: 36px;
    }
  }
}
.customer-container{
  .des{
    position: static;
    padding: 27px !important;
    height: 190px!important;
    i{
      width: 20px;
      height: 3px;
      background-color: #DD122A;
      display: inline-block;
      margin-bottom: 30px!important;
    }
    h3{
      font-size: 18px!important;
      margin-bottom: 20px!important;
      font-weight: 400;
    }
    p{
      color: #666;
      font-size: 12px!important;
      margin-bottom: 10px !important;
    }
    a{
      border: 1px solid #DD122A;
      padding: 1px !important;
      font-size: 14px;
    }
  }
  .des-right{
    padding-right: 10px !important;
    margin-right: -65%!important;
    margin-left: 10px!important;
  }
  .des-left{
    padding-left: 10px !important;
    margin-left: -65%!important;
    margin-right: 10px!important;
  }
}
</style>
